function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 12">
      <path d="m6 0 2 2-4 4 4 4-2 2-6-6 6-6Z" fill="currentColor" />
    </svg>
  );
}

export default Icon;
